import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

const KeywordName = ({ handleKeywordChange, keyword }) => {
  // const keywordArr = keyword.map((el)=>{

  // }
  // )
  return (
    <div>
      <Autocomplete
        size="small"
        multiple
        limitTags={window.innerWidth > 600 ? 7 : 2}
        id="tags-filled"
        value={keyword}
        onChange={handleKeywordChange}
        options={[]}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} label="Keyword Names" />
        )}
      />
    </div>
  );
};

export default KeywordName;
